import { gsap } from "gsap";

export function widthHover() {
  const animationDuration = 0.8;
  const ease = "power2.inOut";
  const blocks = document.querySelectorAll(".heading-interactive-card-container-block");
  const minWidth = 767;
  
  if (!blocks.length) return;

  blocks.forEach((block) => {
    const widthHoverElements = block.querySelectorAll(".animation-width");

    // Disable animation if there is only 1 card
    if (widthHoverElements.length < 2) return;

    const timelines = new Map();
    const firstElement = widthHoverElements[0];

    const createTimeline = (element) => {
      if (timelines.has(element)) {
        return timelines.get(element);
      }

      const widthExtra = element.dataset.widthExtra ? parseFloat(element.dataset.widthExtra) : 0;
      const elementWidth = element.getBoundingClientRect().width;
      const parentWidth = element.parentElement.getBoundingClientRect().width;
      const newWidth = (parentWidth - widthExtra * 5) / 6 + elementWidth + widthExtra;

      const tl = gsap.timeline({ paused: true });
      tl.to(element, {
          flexGrow: 0,
          flexShrink: 0,
          flexBasis: newWidth + 'px',
          duration: animationDuration,
          ease: ease,
      }).reverse();

      timelines.set(element, tl);
      return tl;
    };

    const expandElement = (targetElement) => {
      // Collapse all other elements first
      widthHoverElements.forEach((otherElement) => {
        if (otherElement !== targetElement) {
          const otherTl = timelines.get(otherElement);
          if (otherTl) {
            otherTl.reversed(true);
          }
        }
      });

      // Expand target element
      const tl = createTimeline(targetElement);
      tl.reversed(false);
    };

    // Handle mouse leave on the container to reset to first element
    block.addEventListener('mouseleave', () => {
      if (window.innerWidth >= minWidth) {
        expandElement(firstElement);
      }
    });

    widthHoverElements.forEach((element) => {
      const handleMouseEnter = () => {
        // Disable animation on mobile
        if (window.innerWidth < minWidth) return;

        expandElement(element);
      };

      // Animate on hover
      element.addEventListener('mouseenter', handleMouseEnter);
    });

    // Initialize first element in expanded state (only on desktop)
    if (window.innerWidth >= minWidth && widthHoverElements.length > 0) {
      const firstTl = createTimeline(firstElement);
      firstTl.reversed(false);
    }
  });
}